export default {
  container: {
    display: 'flex',
    alignItems: 'center',
    height: '200px'
  }
}
